import { useContext } from 'react';

import themes from '../constants/themes';
import { ThemeContext } from '../contexts';

export default function useThemeValues() {
  const theme = useContext(ThemeContext);
  return themes[theme];
}
